import DeepLinkHandler from './DeepLinkHandler';

export const EventPage = () => {
  return (
    <div>
      <h1>Opening Hyphii...</h1>
      <p>If you don't have Hyphii installed, you'll be redirected to the App Store.</p>
      <DeepLinkHandler />
    </div>
  );
};